module.exports = __webpack_public_path__ + "static/media/home-banner.cc2a268e.jpg";